import React from 'react'

import CreateUser from '../../components/create-user/CreateUser'
import MainLayout from '../../layout/MainLayout'

const CreateUserPage = () => {
  return (
    <MainLayout>
        <CreateUser />
    </MainLayout>
  )
}

export default CreateUserPage